import styled from 'styled-components';
import { rem } from 'polished';

export const TenantPortingWrapper = styled.div`
  width: 100%;
  padding: ${rem('24px')} ${rem('32px')};
  background: #ffffff;
  border: ${rem('1px')} solid #a8acb8cc;
  border-radius: ${rem('16px')};
  margin-bottom: ${rem('80px')};
`;

export const TenantPortingCallout = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${rem('24px')};
  > * {
    &:first-of-type {
      margin-right: ${rem('12px')};
    }
    &:last-of-type {
      margin-right: 0;
      margin-bottom: 0;
    }
  }
`;
export const TenantPortingContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem('5px')};
`;

export const TenantPortingAdminContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const TenantPortingList = styled.ul`
  list-style-type: disc;
`;

export const TenantPortingItem = styled.li`
  margin: ${rem('10px')} ${rem('10px')};
  font-size: ${rem('20px')};
  font-weight: 500;
  color: #333;
`;

export const TenantPortingButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${rem('10px')};
  padding: ${rem('20px')};
`;
export const TenantPortingTextInput = styled.div`
  display: flex;
  justify-content: center; // horizontal center
  align-items: center;
`;

export const NextStepHeading = styled.div`
  margin-top: ${rem('20px')};
  margin-bottom: ${rem('20px')};
  font-weight: 700;
`;
